import type { ReactElement } from 'react';
import React from 'react';

import { Typography } from '@mui/material';
import { SmallChip } from 'src/components';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  moreTag: {
    marginLeft: theme.spacing(0.5),
  },
  tag: {
    margin: theme.spacing(0.25),
  },
}));

interface FilterTagsProps<T> {
  getTextFromTag: (tag: T) => string;
  onDelete: (tag: T) => void;
  tags: T[];
  truncateTags: boolean;
  getChipIcon?: (tag: T) => ReactElement | undefined;
  numTags?: number;
}

export function FilterTags<T>({
  getChipIcon,
  getTextFromTag,
  numTags = 2,
  onDelete,
  tags,
  truncateTags,
}: FilterTagsProps<T>): JSX.Element {
  const { classes } = useStyles();

  const filterTags = tags.map((tag, index) => {
    return (
      <SmallChip
        key={index}
        className={classes.tag}
        icon={getChipIcon?.(tag)}
        text={getTextFromTag(tag)}
        onDelete={() => onDelete(tag)}
      />
    );
  });
  const more = filterTags.length - numTags;

  if (truncateTags && more > 0) {
    return (
      <>
        {...filterTags.slice(0, numTags)}
        <Typography key={filterTags.length} className={classes.moreTag}>{`+${more}`}</Typography>
      </>
    );
  }

  return <>{filterTags}</>;
}
